

'use strict';

angular.module('pulianiBookStoreApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('trackOrder', {
        url: '/trackOrder',
        templateUrl: 'app/track_order/track_order.html',
        controller: 'TrackOrderComponentCtrl'
      });
  });
